/* GERADO POR ops/scripts/95-assets.mjs. NAO EDITE AQUI.
   O original, com os comentarios que explicam cada decisao, esta em
   assets-src/gl-ui.js. Editar este arquivo faz o trabalho sumir na proxima
   geracao, e o script avisa antes de deixar isso acontecer. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.classList.add('js');


  doc.addEventListener('pointerdown', function () { root.classList.add('toque'); }, true);
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) root.classList.remove('toque');
  }, true);

  var $ = function (sel, ctx) { return (ctx || doc).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };


  function buildRulers() {
    $$('.ruler').forEach(function (el) {
      if (el.children.length) return;
      var n = parseInt(el.dataset.ticks || '40', 10);
      var html = '';
      for (var i = 0; i < n; i++) html += '<i></i>';
      el.innerHTML = html;
    });
  }


  function revealer() {
    var items = $$('.rv');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    items.forEach(function (el) { io.observe(el); });
  }



  function scrollHost() {
    var wrap = $('.page-wrapper');
    if (wrap && getComputedStyle(wrap).overflowY === 'auto') return wrap;
    return null;
  }


  function caixaQueRola() {
    var wrap = $('.page-wrapper');
    if (wrap && wrap.scrollHeight - wrap.clientHeight > 1) return wrap;
    return null;
  }

  function jaRolou() {
    var caixa = caixaQueRola();
    if (caixa) return caixa.scrollTop;
    return window.pageYOffset || doc.documentElement.scrollTop || 0;
  }


  var inscritos = [];
  var quadro = null;
  function passaOQuadro() {
    quadro = null;
    for (var i = 0; i < inscritos.length; i++) inscritos[i]();
  }
  function agendaQuadro() {
    if (quadro !== null) return;

    if (doc.hidden) { passaOQuadro(); return; }
    quadro = window.requestAnimationFrame(passaOQuadro);
  }
  function aoRolar(fn) {
    if (!inscritos.length) {

      var caixa = caixaQueRola();
      if (caixa) caixa.addEventListener('scroll', agendaQuadro, { passive: true });
      window.addEventListener('scroll', agendaQuadro, { passive: true });
      window.addEventListener('resize', agendaQuadro, { passive: true });

      doc.addEventListener('visibilitychange', agendaQuadro);
    }
    inscritos.push(fn);
    fn();
  }

  function progressTape() {
    var fill = $('[data-tape-fill]');
    if (!fill || reduced) return;
    var ticking = false;
    var host = scrollHost();

    function paint() {
      var pos, max;
      if (host) {
        pos = host.scrollTop;
        max = host.scrollHeight - host.clientHeight;
      } else {
        pos = window.scrollY;
        max = doc.documentElement.scrollHeight - window.innerHeight;
      }
      fill.style.width = (max > 0 ? (pos / max) * 100 : 0) + '%';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }

    (host || window).addEventListener('scroll', onScroll, { passive: true });


    window.addEventListener('resize', function () {
      var novo = scrollHost();
      if (novo === host) return;
      (host || window).removeEventListener('scroll', onScroll);
      host = novo;
      (host || window).addEventListener('scroll', onScroll, { passive: true });
      paint();
    }, { passive: true });

    paint();
  }


  function counters() {
    var els = $$('[data-count]');
    if (!els.length) return;

    els.forEach(function (el) {
      var end = parseFloat(el.dataset.count);
      var dec = (el.dataset.count.split(',')[1] || '').length;

      if (reduced || !('IntersectionObserver' in window)) {
        el.textContent = el.dataset.count;
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var t0 = null;
          function step(t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / 1100, 1);
            var v = end * (1 - Math.pow(1 - p, 3));
            el.textContent = dec ? v.toFixed(dec).replace('.', ',') : Math.round(v);
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }


  var Layers = (function () {
    var scrim = $('[data-scrim]');
    var openKey = null;
    var lastFocus = null;


    var travaY = 0;
    function trava() {
      doc.body.classList.add('is-locked');
      if (caixaQueRola()) return;
      travaY = window.pageYOffset || doc.documentElement.scrollTop || 0;
      doc.body.style.position = 'fixed';
      doc.body.style.top = (-travaY) + 'px';
      doc.body.style.left = '0';
      doc.body.style.right = '0';
    }
    function destrava() {
      doc.body.classList.remove('is-locked');
      if (doc.body.style.position !== 'fixed') return;
      doc.body.style.position = '';
      doc.body.style.top = '';
      doc.body.style.left = '';
      doc.body.style.right = '';
      window.scrollTo(0, travaY);
    }

    function panel(key) { return $('[data-layer="' + key + '"]'); }

    function trap(e) {
      if (e.key !== 'Tab' || !openKey) return;
      var p = panel(openKey);
      var f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', p)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open(key) {
      if (openKey) close();
      var p = panel(key);
      if (!p) return;
      lastFocus = doc.activeElement;
      p.classList.add('is-open');
      p.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      trava();
      openKey = key;

      if (!p.hasAttribute('tabindex')) p.setAttribute('tabindex', '-1');
      setTimeout(function () { p.focus({ preventScroll: true }); }, reduced ? 0 : 260);
      doc.addEventListener('keydown', trap);
    }

    function close() {
      if (!openKey) return;
      var p = panel(openKey);
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('is-open');
      destrava();
      doc.removeEventListener('keydown', trap);
      openKey = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    doc.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open]');
      if (o) { e.preventDefault(); open(o.dataset.open); return; }
      if (e.target.closest('[data-close]')) close();
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    return { open: open, close: close };
  })();


  function selectGroups() {
    $$('[data-select]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || btn.getAttribute('aria-pressed') === 'true') return;

        $$('[data-value]', group).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');

        var out = group.dataset.out ? $(group.dataset.out) : null;
        if (out) out.textContent = btn.dataset.label || btn.dataset.value;

        group.dispatchEvent(new CustomEvent('gl:select', {
          bubbles: true,
          detail: { name: group.dataset.select, value: btn.dataset.value, el: btn }
        }));
      });
    });
  }


  function sizeTable() {
    doc.addEventListener('gl:select', function (e) {
      if (e.detail.name !== 'numero') return;
      $$('[data-col]').forEach(function (cell) {
        cell.classList.toggle('is-on', cell.dataset.col === e.detail.value);
      });
    });
  }



  function galeria() {
    var caixa = $('[data-gal]');
    if (!caixa) return;
    var trilho = $('[data-gal-trilho]', caixa);
    if (!trilho) return;

    var slides = $$('.gl-gal__slide', trilho);
    if (slides.length < 2) return;

    var pontos = $('[data-gal-pontos]', caixa);
    var ant = $('[data-gal-ant]', caixa);
    var prox = $('[data-gal-prox]', caixa);

    function passo() {
      return slides[0].getBoundingClientRect().width + 12;
    }
    function indice() {
      return Math.round(trilho.scrollLeft / passo());
    }
    function vai(i) {
      var n = Math.max(0, Math.min(i, slides.length - 1));
      trilho.scrollTo({ left: n * passo(), behavior: reduced ? 'auto' : 'smooth' });
    }

    if (pontos) {
      slides.forEach(function (s, i) {
        var b = doc.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' de ' + slides.length);
        b.addEventListener('click', function () { vai(i); });
        pontos.appendChild(b);
      });
    }

    function pinta() {
      var i = indice();
      if (pontos) {
        $$('button', pontos).forEach(function (b, n) {
          b.classList.toggle('is-on', n === i);
          b.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
      }
      if (ant) ant.disabled = i <= 0;
      if (prox) prox.disabled = i >= slides.length - 1;
    }

    if (ant) ant.addEventListener('click', function () { vai(indice() - 1); });
    if (prox) prox.addEventListener('click', function () { vai(indice() + 1); });

    var esperando = false;
    trilho.addEventListener('scroll', function () {
      if (esperando) return;
      esperando = true;
      requestAnimationFrame(function () { pinta(); esperando = false; });
    }, { passive: true });

    window.addEventListener('resize', pinta, { passive: true });
    pinta();
  }


  function deliveryEta() {
    var box = $('[data-eta]');
    if (!box) return;


    var cfg;
    try { cfg = JSON.parse(box.dataset.eta); } catch (e) { return; }
    if (!cfg || !cfg.min || !cfg.max) return;

    var dateEl = $('[data-eta-date]', box);
    if (!dateEl || !box.dataset.etaTpl) return;

    var MES = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.',
               'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'];

    function addBiz(from, n) {
      var d = new Date(from), c = 0;
      while (c < n) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6) c++;
      }
      return d;
    }
    function fmt(d) { return d.getDate() + ' de ' + MES[d.getMonth()]; }

    var hoje = new Date();
    dateEl.textContent = box.dataset.etaTpl
      .replace('{de}', fmt(addBiz(hoje, cfg.min)))
      .replace('{ate}', fmt(addBiz(hoje, cfg.max)));
  }



  var GAVETA = 'gl-sacola-gaveta';

  function trocaGaveta(html) {
    if (!html) return;
    var doc2 = new DOMParser().parseFromString(html, 'text/html');
    var origem = doc2.querySelector('[data-layer="cart"]');
    var destino = $('[data-layer="cart"]');
    if (!origem || !destino) return;
    destino.innerHTML = origem.innerHTML;
    destino.dataset.conta = origem.dataset.conta || '';
    pintaContador(origem.dataset.conta);

    convenio();
  }

  function pintaContador(n) {

    var q = parseInt(n, 10) || 0;
    $$('[data-bag-count]').forEach(function (b) {
      b.textContent = q;
      b.removeAttribute('hidden');
    });
  }


  function sacolaAjax() {
    if (!window.fetch || !window.FormData) return;

    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.gl-sac__acao')) return;
      e.preventDefault();


      var naGaveta = !!form.closest('[data-layer="cart"]');
      var secaoPagina = null;
      if (!naGaveta) {
        var sp = form.closest('.shopify-section');
        secaoPagina = sp ? sp.id.replace('shopify-section-', '') : null;
      }
      var secoes = secaoPagina ? GAVETA + ',' + secaoPagina : GAVETA;


      var dados = new FormData(form);
      var chave = dados.get('id');
      var qtd = parseInt(dados.get('quantity'), 10);
      var botao = e.submitter || $('[form="' + form.id + '"]');
      var item = botao && botao.closest('li');
      if (qtd === 0 && item && !reduced) item.classList.add('is-saindo');
      if (botao) botao.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: chave, quantity: qtd, sections: secoes })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('falhou');
          return r.json();
        })
        .then(function (c) {

          setTimeout(function () {
            if (c.sections) trocaGaveta(c.sections[GAVETA]);
            else pintaContador(c.item_count);
            if (secaoPagina && c.sections && c.sections[secaoPagina]) {
              var alvo = doc.getElementById('shopify-section-' + secaoPagina);
              var novo = new DOMParser().parseFromString(c.sections[secaoPagina], 'text/html')
                .getElementById('shopify-section-' + secaoPagina);
              if (alvo && novo) {
                alvo.innerHTML = novo.innerHTML;

                $$('.rv', alvo).forEach(function (el) { el.classList.add('is-in'); });
                convenio();
              }
            }
          }, qtd === 0 && !reduced ? 220 : 0);
        })
        .catch(function () {

          form.submit();
        });
    });
  }

  function addToCart() {
    var form = $('#gl-form-produto');
    if (!form || !window.fetch || !window.FormData) return;

    function avisa(msg) {
      var alvo = $('[data-cart-erro]', form);
      if (!alvo) return;
      alvo.textContent = msg;
      alvo.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      var botao = $('[name="add"]', form);
      var alvoErro = $('[data-cart-erro]', form);
      if (alvoErro) alvoErro.hidden = true;

      e.preventDefault();
      if (botao) {
        botao.setAttribute('aria-busy', 'true');
        botao.disabled = true;
      }


      var dados = new FormData(form);
      dados.append('sections', GAVETA);


      var vid = String(dados.get('id') || '');
      var qtd = parseInt(dados.get('quantity') || '1', 10) || 1;
      var mapa = {};
      try { mapa = JSON.parse(($('[data-gl-estoque]', form) || {}).textContent || '{}'); } catch (x) {}
      var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];

      var confere = Promise.all([
        handle ? fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }) : null,
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      ]).then(function (res) {
        return { prod: res[0], sac: res[1] };
      }, function () { return null; }).then(function (res) {
        if (!res) return;
        var v = res.prod && res.prod.variants.filter(function (x) { return String(x.id) === vid; })[0];
        if (v && !v.available) throw new Error('Este número esgotou. Escolha outro, ou veja o sob medida.');
        if (mapa[vid] != null) {
          var ja = 0;
          res.sac.items.forEach(function (i) { if (String(i.variant_id) === vid) ja += i.quantity; });
          if (ja + qtd > mapa[vid]) {
            throw new Error(ja
              ? 'Você já tem no carrinho ' + (ja === 1 ? 'a única peça' : 'as ' + ja + ' peças') + ' que temos neste número.'
              : 'Temos ' + mapa[vid] + ' neste número.');
          }
        }
      });

      confere.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: dados
        });
      })
        .then(function (r) {
          return r.json().then(function (corpo) { return { ok: r.ok, corpo: corpo }; });
        })
        .then(function (res) {
          if (!res.ok) {
            throw new Error((res.corpo && res.corpo.description) || 'Não deu para adicionar esta peça.');
          }
          if (res.corpo.sections) trocaGaveta(res.corpo.sections[GAVETA]);
          Layers.open('cart');
          doc.dispatchEvent(new CustomEvent('gl:cart-add'));
        })
        .catch(function (err) {
          avisa(err && err.message ? err.message : 'Não deu para adicionar esta peça.');
        })
        .then(function () {
          if (botao) {
            botao.removeAttribute('aria-busy');
            botao.disabled = false;
          }
        });
    });
  }


  function stickyBuy() {
    var barra = $('[data-sticky-buy]');
    var gatilho = $('.gl-pdp__cta');
    if (!barra || !gatilho || !('IntersectionObserver' in window)) return;

    var passouDoCta = false;
    var chegouNoPe = false;

    function pinta() {
      barra.classList.toggle('is-on', passouDoCta && !chegouNoPe);
      barra.setAttribute('aria-hidden', passouDoCta && !chegouNoPe ? 'false' : 'true');
    }


    new IntersectionObserver(function (entradas) {
      var e = entradas[0];
      passouDoCta = !e.isIntersecting && e.boundingClientRect.top < 0;
      pinta();
    }, { threshold: 0 }).observe(gatilho);

    var pe = $('footer .gl-pe') || $('.gl-pe');
    if (pe) {
      new IntersectionObserver(function (entradas) {
        chegouNoPe = entradas[0].isIntersecting;
        pinta();
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 }).observe(pe);
    }

    pinta();
  }


  function leadModal() {
    var modal = $('[data-layer="lead"]');
    if (!modal) return;

    var steps = $$('[data-step]', modal);
    var echo = $('[data-pick-echo]', modal);

    function go(n) {
      steps.forEach(function (s) { s.classList.toggle('is-on', s.dataset.step === String(n)); });
    }

    $$('[data-pick]', modal).forEach(function (b) {
      b.addEventListener('click', function () {
        if (echo) echo.textContent = b.dataset.pick;
        go(2);
        var i = $('[data-lead-email]', modal);
        if (i) setTimeout(function () { i.focus(); }, 80);
      });
    });

    var submit = $('[data-lead-submit]', modal);
    if (submit) submit.addEventListener('click', function () {
      var i = $('[data-lead-email]', modal);
      if (!i || !i.value || i.value.indexOf('@') < 0) {
        if (i) { i.focus(); i.closest('.field').classList.add('is-bad'); }
        return;
      }
      doc.dispatchEvent(new CustomEvent('gl:lead', { detail: { email: i.value } }));
      go(3);
    });

    var toCart = $('[data-lead-cart]', modal);
    if (toCart) toCart.addEventListener('click', function () { go(1); Layers.open('cart'); });
  }


  function fundoAssenta() {

    var secoes = $$('.gl-sec').filter(function (s) { return s.querySelector('.bg-art img'); });
    if (!secoes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      secoes.forEach(function (s) { s.classList.add('is-vista'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-vista');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.02 });

    secoes.forEach(function (s) { io.observe(s); });
  }



  function avisoAltura() {
    var av = $('.gl-aviso');
    if (!av) return;
    var escreve = function () {
      var h = Math.round(av.getBoundingClientRect().height);
      if (h > 0) doc.documentElement.style.setProperty('--aviso-h', h + 'px');
    };
    escreve();
    if (window.ResizeObserver) new ResizeObserver(escreve).observe(av);
    else window.addEventListener('resize', escreve, { passive: true });
  }


  function barraApp() {
    var barra = $('[data-tabbar]');
    if (!barra) return;


    if (barra.parentNode !== doc.body) doc.body.appendChild(barra);


    var grupo = doc.getElementById('header-group');
    function medeTopo() {
      if (!grupo) return;
      var h = Math.round(grupo.getBoundingClientRect().height);
      if (h > 0) doc.documentElement.style.setProperty('--topo-fixo-h', h + 'px');
    }
    medeTopo();
    if (grupo && window.ResizeObserver) new ResizeObserver(medeTopo).observe(grupo);
    else window.addEventListener('resize', medeTopo, { passive: true });

    var pe = $('.gl-pe');
    var rolou = false;
    var noRodape = false;

    function aplica() {
      barra.hidden = !(rolou && !noRodape);
      doc.body.classList.toggle('tem-tabbar', !barra.hidden);
      doc.body.classList.toggle('rolou', rolou);
    }




    var SOBE = 96, VOLTA = 8;

    aoRolar(function () {
      var y = jaRolou();
      if (!rolou && y > SOBE) { rolou = true; aplica(); }
      else if (rolou && y < VOLTA) { rolou = false; aplica(); }
    });


    var curta = false;
    function medeAltura() {
      var alvo = $('.page-wrapper') || doc.documentElement;
      curta = (alvo.scrollHeight - alvo.clientHeight) < 700;
    }
    medeAltura();
    window.addEventListener('resize', medeAltura, { passive: true });

    if (pe) {
      new IntersectionObserver(function (e) {
        noRodape = curta ? false : e[0].isIntersecting;
        aplica();
      }, { threshold: 0, rootMargin: '0px 0px -75% 0px' }).observe(pe);
    }

    aplica();
  }



  var convenioPendente = null;
  function convenio() {
    var novos = $$('[name^="attributes["]').filter(function (c) {
      return !c.dataset.glConvenio;
    });
    if (!novos.length) return;
    novos.forEach(function (c) { c.dataset.glConvenio = '1'; });

    function todos() { return $$('[name^="attributes["]'); }

    function grava() {
      var attrs = {};
      todos().forEach(function (c) {
        var m = c.name.match(/^attributes\[(.+)\]$/);
        if (m) attrs[m[1]] = c.value.trim();
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {

      });
    }

    novos.forEach(function (c) {
      c.addEventListener('input', function () {

        todos().forEach(function (o) {
          if (o !== c && o.name === c.name) o.value = c.value;
        });
        clearTimeout(convenioPendente);
        convenioPendente = setTimeout(grava, 700);
      });
      c.addEventListener('blur', function () {
        clearTimeout(convenioPendente);
        grava();
      });
    });
  }



  function cardOpcoes() {
    $$('[data-card-opts]').forEach(cardOpcoesUm);
  }

  function cardOpcoesUm(caixa) {
    var dados = $('[data-card-json]', caixa);
    var grupos = $$('[data-variant-opt]', caixa);
    if (!dados || !grupos.length) return;

    var variants = [];
    try { variants = JSON.parse(dados.textContent); } catch (e) { return; }

    var corpo = caixa.closest('.gl-dest__corpo, .gl-col__corpo') || caixa.parentNode;
    var cta = $('.btn--metal', corpo);
    var base = caixa.dataset.cardUrl || '';

    function escolhidas() {
      return grupos.map(function (g) {
        var on = $('[aria-pressed="true"]', g);
        return on ? on.dataset.optValue : null;
      });
    }

    function pinta() {
      var sel = escolhidas();

      grupos.forEach(function (g, iOpt) {
        $$('[data-opt-value]', g).forEach(function (bt) {
          var existe = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) {
              return k === iOpt ? o === bt.dataset.optValue : o === sel[k];
            });
          });
          var cor = bt.classList.contains('swatch');
          bt.classList.toggle(cor ? 'swatch--fora' : 'chip--fora', !existe);
          bt.setAttribute('aria-disabled', String(!existe));
        });
        var mostra = $('[data-opt-out="' + iOpt + '"]', caixa);
        if (mostra) mostra.textContent = sel[iOpt] || '';
      });


      if (cta && base) {
        var achou = variants.find(function (v) {
          return sel.every(function (val, i) { return v.options[i] === val; });
        });
        cta.href = achou ? base + '?variant=' + achou.id : base;
      }
    }

    caixa.addEventListener('click', function (e) {
      var bt = e.target.closest('[data-opt-value]');
      if (!bt) return;
      e.preventDefault();
      var g = bt.closest('[data-variant-opt]');
      $$('[data-opt-value]', g).forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === bt));
      });
      pinta();
    });

    pinta();
  }


  function pontas() {
    var blocos = $$('main .shopify-section > *, .gl-pe').filter(function (el) {
      if (/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(el.tagName)) return false;
      return el.offsetHeight > 0;
    });

    function fundo(el) {
      if (!el) return '';
      var c = getComputedStyle(el).backgroundColor;
      return (!c || c === 'transparent' || c === 'rgba(0, 0, 0, 0)') ? '' : c;
    }

    blocos.forEach(function (s, i) {
      var cortada = s.matches('.gl-sec--dark, .gl-sec--blue, .gl-pe') && !s.matches('.gl-capa');
      if (!cortada) return;
      var antes = blocos[i - 1];
      var depois = blocos[i + 1];
      var topo = fundo(antes);
      var base = fundo(depois);
      if (topo) s.style.setProperty('--viz-topo', topo);
      if (base) s.style.setProperty('--viz-base', base);
      s.style.borderTopWidth = '0';
      s.style.borderBottomWidth = '0';
      if (antes) antes.style.borderBottomWidth = '0';
      if (depois) depois.style.borderTopWidth = '0';
    });
  }


  function guiaVideo() {
    var loops = $$('[data-gv-loop]');
    var poupa = reduced || (navigator.connection && navigator.connection.saveData);
    function toca(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

    loops.forEach(function (v) {
      v.muted = true;
      if (poupa) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (!poupa && loops.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) toca(e.target); else e.target.pause(); });
      });
      loops.forEach(function (v) { io.observe(v); });
    }

    var lux = $('[data-layer="video"]');
    var palco = lux && $('[data-lux-palco]', lux);
    if (!lux || !palco) return;


    var tela = $('[data-lux-video]', lux);
    var tocar = $('[data-lux-tocar]', lux);

    var ua = navigator.userAgent;
    var hls = !!(tela && tela.canPlayType('application/vnd.apple.mpegurl') &&
      (/iPhone|iPad|iPod|Android/.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR/.test(ua))));

    function fonte(t) {
      var fontes = $$('source', t.content).map(function (s) {
        return { src: s.getAttribute('src'), tipo: s.getAttribute('type') || '', h: parseInt(s.getAttribute('data-h'), 10) || 0 };
      });
      var m3u8 = fontes.filter(function (f) { return /mpegurl/i.test(f.tipo) || /\.m3u8/.test(f.src); })[0];
      var mp4 = fontes.filter(function (f) { return /mp4/.test(f.tipo) || /\.mp4/.test(f.src); });
      if (hls && m3u8) return m3u8.src;

      var celular = window.matchMedia('(max-width: 759.98px)').matches;
      var alvo = celular ? 720 : 1080;
      var escolha = mp4.filter(function (f) { return f.h === alvo || new RegExp(alvo + 'p').test(f.src); })[0];
      return (escolha || mp4[0] || fontes[0] || {}).src;
    }

    function abre(gatilho) {
      var t = $('template[data-gv-video]', gatilho);
      if (!t || !tela) return;
      var src = fonte(t);
      if (!src) return;
      var capa = $('video', t.content);
      if (capa && capa.getAttribute('poster')) tela.setAttribute('poster', capa.getAttribute('poster'));
      if (tela.getAttribute('src') !== src) tela.setAttribute('src', src);
      tela.muted = false;
      if (tocar) tocar.hidden = true;
      Layers.open('video');
      var p = tela.play();
      if (p && p.catch) p.catch(function () { if (tocar) tocar.hidden = false; });
    }

    if (tocar) {
      tocar.addEventListener('click', function () {
        tocar.hidden = true;
        var p = tela.play();
        if (p && p.catch) p.catch(function () { tocar.hidden = false; });
      });
    }
    if (tela) tela.addEventListener('playing', function () { if (tocar) tocar.hidden = true; });

    doc.addEventListener('click', function (e) {
      var par = e.target.closest('[data-gv-par]');
      var g = e.target.closest('[data-gv-abre]');
      if (par) {
        var grupo = par.closest('[data-gv-grupo]');
        g = grupo && $('[data-gv-abre]', grupo);
      }
      if (!g) return;
      e.preventDefault();
      abre(g);
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var g = e.target.closest && e.target.closest('[data-gv-abre][role="button"]');
      if (!g) return;
      e.preventDefault();
      abre(g);
    });

    lux.addEventListener('click', function (e) { if (e.target === lux) Layers.close(); });

    new MutationObserver(function () {
      if (lux.classList.contains('is-open') || !tela) return;
      tela.pause();
      try { tela.currentTime = 0; } catch (e) {}
      if (tocar) tocar.hidden = true;
    }).observe(lux, { attributes: true, attributeFilter: ['class'] });
  }

  function folhaMedidas() {
    var folha = $('[data-layer="medidas"]');
    if (!folha) return;
    var abas = $$('[data-folha-aba]', folha);
    abas.forEach(function (a) {
      a.addEventListener('click', function () {
        abas.forEach(function (o) { o.setAttribute('aria-selected', String(o === a)); });
        $$('[data-folha-painel]', folha).forEach(function (p) { p.hidden = p.dataset.folhaPainel !== a.dataset.folhaAba; });
      });
    });

    doc.addEventListener('click', function (e) {
      if (!e.target.closest('[data-open="medidas"]')) return;
      var marcado = $('#gl-form-produto [data-variant-opt] [aria-pressed="true"][data-opt-value^="N"]') ||
                    $('#gl-form-produto [aria-pressed="true"][data-opt-value*="º"]');
      var n = marcado ? (marcado.dataset.optValue.match(/\d/) || [])[0] : null;
      $$('[data-col]', folha).forEach(function (c) { c.classList.toggle('is-meu', !!n && c.dataset.col === n); });
    }, true);
  }

  function capaTopo() {
    var capa = $('.gl-capa--topo');
    if (!capa) return;

    doc.body.dataset.topo = 'claro';


    aoRolar(function () {
      var y = jaRolou();
      if (doc.body.dataset.topo !== 'solido') {
        if (y > 12) doc.body.dataset.topo = 'solido';
      } else if (y <= 2) {
        doc.body.dataset.topo = 'claro';
      }
    });
  }



  function sincronizaSacola() {
    var bolhas = $$('[data-bag-count]');
    if (!bolhas.length || !window.fetch) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c && typeof c.item_count === 'number' ? c.item_count : null;
        if (n === null) return;


        bolhas.forEach(function (b) {
          b.textContent = n;
          b.removeAttribute('hidden');
          var botao = b.closest('button');
          if (botao) {
            botao.setAttribute('aria-label', 'Abrir carrinho, ' + n + ' ' + (n === 1 ? 'item' : 'itens'));
          }
        });
      })
      .catch(function () {  });
  }

  function bagFeedback() {
    doc.addEventListener('gl:cart-add', function () {
      if (reduced) return;
      $$('[data-bag-count]').forEach(function (b) {
        b.classList.remove('is-bump');
        void b.offsetWidth;
        b.classList.add('is-bump');
      });
    });
  }



  function rotulo(btn, texto) {
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) { n.nodeValue = texto + ' '; return; }
    }
    btn.insertBefore(doc.createTextNode(texto + ' '), btn.firstChild);
  }

  function variantPicker() {
    var form = $('#gl-form-produto');
    if (!form) return;

    var hidden = $('[data-variant-id]', form);
    var grupos = $$('[data-variant-opt]', form);
    if (!hidden || !grupos.length) return;

    var dados = $('[data-variant-json]');
    var variants = [];
    try { variants = JSON.parse(dados.textContent); } catch (e) { return; }

    function escolhidas() {
      return grupos.map(function (g) {
        var on = $('[aria-pressed="true"]', g);
        return on ? on.dataset.optValue : null;
      });
    }

    function aplica() {
      var sel = escolhidas();
      var achou = variants.find(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      });
      if (!achou) return;

      hidden.value = achou.id;


      var sPreco = $('[data-sticky-preco]');
      if (sPreco && achou.price) sPreco.textContent = achou.price;
      var sVar = $('[data-sticky-var]');
      if (sVar) sVar.textContent = sel.filter(Boolean).join(', ');
      var sPix = $('[data-sticky-pix]');
      if (sPix && achou.pix) sPix.textContent = achou.pix + ' no Pix';

      var sBtn = $('[data-sticky-add]');
      if (sBtn) {
        if (!sBtn.dataset.rotulo) sBtn.dataset.rotulo = sBtn.textContent.trim();
        sBtn.disabled = !achou.available;
        rotulo(sBtn, achou.available ? sBtn.dataset.rotulo : 'Esgotado');
      }


      var sAvisa = $('[data-sticky-avisa]');
      if (sAvisa) sAvisa.hidden = achou.available;

      var preco = $('.gl-price strong');
      if (preco && achou.price) preco.textContent = achou.price;

      var cta = $('.gl-pdp__cta', form);
      if (cta) {

        if (!cta.dataset.rotulo) cta.dataset.rotulo = cta.textContent.trim();
        cta.disabled = !achou.available;
        rotulo(cta, achou.available ? cta.dataset.rotulo : 'Esgotado');
        cta.setAttribute('aria-disabled', String(!achou.available));
      }


      grupos.forEach(function (grupo, iOpt) {
        $$('[data-opt-value]', grupo).forEach(function (bt) {
          var existe = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) {
              return k === iOpt ? o === bt.dataset.optValue : o === sel[k];
            });
          });
          bt.classList.toggle(bt.classList.contains('swatch') ? 'swatch--fora' : 'chip--fora', !existe);
          if (existe) { bt.removeAttribute('data-fora'); }
          else { bt.setAttribute('data-fora', ''); }
        });
      });


      var num = sel.find(function (s) { return s && /Nº\s*\d/.test(s); });
      if (num) {
        var n = num.replace(/\D/g, '');
        $$('[data-col]').forEach(function (c) {
          c.classList.toggle('is-on', c.dataset.col === n);
        });
      }
    }

    grupos.forEach(function (g, i) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-opt-value]');
        if (!b || b.getAttribute('aria-pressed') === 'true') return;

        $$('[data-opt-value]', g).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');

        var out = $('[data-opt-out="' + i + '"]', form);
        if (out) out.textContent = b.dataset.optValue;

        aplica();
      });
    });

    aplica();
  }


  function convenioCupom() {
    function secaoDaPagina(el) {
      if (el.closest('[data-layer="cart"]')) return null;
      var sp = el.closest('.shopify-section');
      return sp ? sp.id.replace('shopify-section-', '') : null;
    }

    function redesenha(c, pagina) {
      if (c.sections) trocaGaveta(c.sections[GAVETA]);
      if (pagina && c.sections && c.sections[pagina]) {
        var alvo = doc.getElementById('shopify-section-' + pagina);
        var novo = new DOMParser().parseFromString(c.sections[pagina], 'text/html')
          .getElementById('shopify-section-' + pagina);
        if (alvo && novo) {
          alvo.innerHTML = novo.innerHTML;
          $$('.rv', alvo).forEach(function (el) { el.classList.add('is-in'); });
          convenio();
        }
      }
    }

    function envia(bloco, corpo, botao) {
      var pagina = secaoDaPagina(bloco);
      corpo.sections = pagina ? GAVETA + ',' + pagina : GAVETA;
      if (botao) { botao.disabled = true; botao.setAttribute('aria-busy', 'true'); }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo)
      }).then(function (r) {
        if (!r.ok) throw new Error('falhou');
        return r.json();
      }).then(function (c) {
        redesenha(c, pagina);
        return c;
      });
    }

    function erro(bloco, msg) {
      var p = $('[data-oab-erro]', bloco);
      if (!p) return;
      p.textContent = msg || '';
      p.hidden = !msg;
    }

    doc.addEventListener('click', function (e) {
      var aplica = e.target.closest && e.target.closest('[data-oab-aplica]');
      var tira = e.target.closest && e.target.closest('[data-oab-tira]');
      if (!aplica && !tira) return;
      var bloco = (aplica || tira).closest('[data-oab]');
      if (!bloco) return;
      e.preventDefault();
      var cupom = bloco.dataset.oabCupom || 'OAB10';

      if (tira) {
        envia(bloco, { discount: '' }, tira).catch(function () {
          tira.disabled = false;
          erro(bloco, 'Não deu para tirar agora. Tente de novo.');
        });
        return;
      }

      var num = $('[name="attributes[Inscricao OAB]"]', bloco);
      var sec = $('[name="attributes[Seccional OAB]"]', bloco);
      var n = num ? num.value.trim() : '';
      var sc = sec ? sec.value.trim() : '';
      if ((n.match(/[0-9]/g) || []).length < 3) { erro(bloco, 'Escreva o número da inscrição na OAB.'); if (num) num.focus(); return; }
      if (sc.length < 2) { erro(bloco, 'Escreva a seccional, por exemplo OAB/GO.'); if (sec) sec.focus(); return; }
      erro(bloco, '');
      clearTimeout(convenioPendente);

      envia(bloco, {
        attributes: { 'Inscricao OAB': n, 'Seccional OAB': sc },
        discount: cupom
      }, aplica).then(function (c) {
        var ok = (c.discount_codes || []).some(function (d) {
          return String(d.code).toUpperCase() === cupom.toUpperCase() && d.applicable;
        });
        if (!ok) {
          erro($('[data-layer="cart"] [data-oab]') || bloco, 'O convênio não pôde ser aplicado agora. Fale com o ateliê pelo WhatsApp.');
        }
      }).catch(function () {
        aplica.disabled = false;
        aplica.removeAttribute('aria-busy');
        erro(bloco, 'Não deu para aplicar agora. Tente de novo.');
      });
    });
  }


  var YAMPI_API = 'https://api.dooki.com.br/v2/public/shopify/cart';

  function yampiLimpa() {
    $$('#ymp-btn-style, .ymp_elem_mainBtn').forEach(function (n) { n.remove(); });
  }

  function fechaPedido() {

    if ($('.yampi-loader')) {
      yampiLimpa();
      var ob = new MutationObserver(yampiLimpa);
      ob.observe(doc.documentElement, { childList: true, subtree: true });
      setTimeout(function () { ob.disconnect(); }, 30000);
    }

    function comPrazo(url, opt) {
      var ctl = window.AbortController ? new AbortController() : null;
      var t = ctl && setTimeout(function () { ctl.abort(); }, 10000);
      if (ctl) opt.signal = ctl.signal;
      return fetch(url, opt).then(function (r) {
        clearTimeout(t);
        if (!r.ok) throw new Error(url + ' ' + r.status);
        return r.json();
      });
    }

    function endereco() {
      return comPrazo('/cart.js', { headers: { Accept: 'application/json' } }).then(function (carrinho) {
        if (!carrinho.item_count) return { vazio: true };
        return confereEstoque(carrinho).then(function (falta) {
          if (falta.length) return { falta: falta };
          var cupom = (carrinho.discount_codes || []).filter(function (d) { return d.applicable; })
            .map(function (d) { return d.code; })[0];
          return pedeYampi(carrinho).then(function (r) {
            if (r && cupom) r.cupom = cupom;
            return r;
          });
        });
      });
    }


    function confereEstoque(carrinho) {
      var handles = [];
      carrinho.items.forEach(function (i) { if (handles.indexOf(i.handle) < 0) handles.push(i.handle); });
      return Promise.all(handles.map(function (h) {
        return comPrazo('/products/' + h + '.js', { headers: { Accept: 'application/json' } });
      })).then(function (produtos) {
        var livre = {};
        produtos.forEach(function (p) { p.variants.forEach(function (v) { livre[v.id] = v.available; }); });
        return carrinho.items.filter(function (i) { return livre[i.variant_id] === false; })
          .map(function (i) { return (i.variant_title || i.product_title).split(' / ').join(' '); });
      }).catch(function () { return []; });
    }

    function pedeYampi(carrinho) {
      var loja = window.Shopify && Shopify.shop;
      var host = location.host;

      if (/^(127\.|localhost)/.test(host) && loja) host = loja;
      return comPrazo(YAMPI_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ shop: host, shopify_internal_domain: loja, cart_payload: carrinho })
      });
    }

    function estado(btn, indo) {
      if (!btn) return;
      var txt = Array.prototype.filter.call(btn.childNodes, function (n) {
        return n.nodeType === 3 && n.textContent.trim();
      })[0];
      if (indo) {
        if (txt && !btn.dataset.rotulo) btn.dataset.rotulo = txt.textContent;
        if (txt) txt.textContent = ' Abrindo o pagamento ';
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-indo');
      } else {
        if (txt && btn.dataset.rotulo) txt.textContent = btn.dataset.rotulo;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-indo');
      }
    }

    function avisa(form, btn, msg) {
      var p = $('.gl-ordem__erro', form);
      if (!msg) { if (p) p.remove(); return; }
      if (!p) {
        p = doc.createElement('p');
        p.className = 'gl-ordem__erro';
        p.setAttribute('role', 'alert');
        btn.insertAdjacentElement('afterend', p);
      }
      p.textContent = msg;
    }

    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.gl-sac__form')) return;
      var btn = e.submitter || $('[name="checkout"]', form);
      if (btn && btn.name && btn.name !== 'checkout') return;
      e.preventDefault();
      if (form.dataset.glIndo) return;
      if ($('[data-esgotou]', form)) {
        avisa(form, btn, 'Uma peça da sua ordem esgotou ou passou do estoque. Ajuste a linha marcada para seguir.');
        return;
      }
      form.dataset.glIndo = '1';
      estado(btn, true);
      avisa(form, btn, '');

      var attrs = {};
      $$('[name^="attributes["]', form).forEach(function (c) {
        var m = c.name.match(/^attributes\[(.+)\]$/);
        if (m) attrs[m[1]] = c.value.trim();
      });
      clearTimeout(convenioPendente);
      var grava = Object.keys(attrs).length
        ? comPrazo('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).catch(function () {})
        : Promise.resolve();

      function falha() {
        delete form.dataset.glIndo;
        estado(btn, false);
        avisa(form, btn, 'O pagamento não abriu. Toque de novo em Fechar pedido. Se repetir, fale com o ateliê pelo WhatsApp.');
      }


      grava.then(endereco).catch(endereco).then(function (r) {
        if (r && r.vazio) { location.href = '/cart'; return; }
        if (r && r.falta) {
          delete form.dataset.glIndo;
          estado(btn, false);
          avisa(form, btn, (r.falta.length > 1 ? 'Esgotaram: ' : 'Esgotou: ') + r.falta.join(', ') + '. Tire da ordem para seguir.');
          return;
        }
        if (r && r.active === false) { location.href = '/checkout'; return; }
        if (!r || !r.checkout_direct_url) throw new Error('sem endereço');
        var url = r.checkout_direct_url;

        if (r.cupom) url += (url.indexOf('?') < 0 ? '?' : '&') + 'promocode=' + encodeURIComponent(r.cupom);
        if (typeof window.ymp_getUrlWithUtms === 'function') {
          try { url = window.ymp_getUrlWithUtms(url) || url; } catch (x) {}
        }
        location.href = url;
      }).catch(falha);
    }, true);

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      $$('.gl-sac__form').forEach(function (f) {
        delete f.dataset.glIndo;
        estado($('[name="checkout"]', f), false);
      });
    });
  }



  function liga(nome, fn) {
    try { fn(); }
    catch (e) { (console.error || console.log).call(console, '[GL] ' + nome + ' falhou:', e); }
  }

  function init() {
    liga('buildRulers', buildRulers);
    liga('revealer', revealer);
    liga('fundoAssenta', fundoAssenta);
    liga('avisoAltura', avisoAltura);
    liga('barraApp', barraApp);
    liga('cardOpcoes', cardOpcoes);
    liga('convenio', convenio);
    liga('capaTopo', capaTopo);
    liga('pontas', pontas);
    liga('guiaVideo', guiaVideo);
    liga('folhaMedidas', folhaMedidas);
    liga('progressTape', progressTape);
    liga('counters', counters);
    liga('selectGroups', selectGroups);
    liga('variantPicker', variantPicker);
    liga('sizeTable', sizeTable);
    liga('galeria', galeria);
    liga('addToCart', addToCart);
    liga('sacolaAjax', sacolaAjax);
    liga('stickyBuy', stickyBuy);
    liga('deliveryEta', deliveryEta);
    liga('leadModal', leadModal);
    liga('sincronizaSacola', sincronizaSacola);
    liga('bagFeedback', bagFeedback);
    liga('fechaPedido', fechaPedido);
    liga('convenioCupom', convenioCupom);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  window.GL = { layers: Layers };
})();
